import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { MainWrapper } from 'legacyComponents/styled/lib';

import { Readme } from 'apps/readme';

import { ProjectOverview } from 'apps/project/views/overview';
import { VersionWarning } from 'apps/project/views/versionWarning';
import { conf } from 'apps/project/config.yaml';

// import { CardSection } from 'legacyComponents/layout/cardSection';
// import { ProjectCard } from 'legacyComponents/cards/types/project';

@withNamespaces()
@observer
export class ProjectHome extends React.Component {
  render() {
    const { projectManager, params, repoManager, t } = this.props;

    // const { suggestedProjectsConnection, project } = projectManager;
    // const suggestedProjects = suggestedProjectsConnection?.arrayApp;

    // const hasReadme = !!repoManager.repository?.FindFileCWD('README.md');

    // const suggestedProjectsComponent = project &&
    //   !project.canUpdate &&
    //   suggestedProjectsConnection && (
    //     <CardSection
    //       title='Browse Similar Projects'
    //       subTitle={' '}
    //       isOwnProfile={false}
    //       ownerName=''
    //       cardApp={suggestedProjects}
    //       CardComponent={ProjectCard}
    //       noDataCardType='project'
    //       spaceType='discover'
    //       gridColumns={3}
    //       last
    //     />
    //   );
    return (
      <MainWrapper>
        <VersionWarning repoManager={repoManager} />
        <ProjectOverview
          projectManager={projectManager}
          repoManager={repoManager}
        />

        {/* {!hasReadme && suggestedProjectsComponent} */}

        <Readme
          title={t(conf.sections[2])}
          params={params}
          repoManager={repoManager}
          project={projectManager.project}
          last
        />

        {/* {hasReadme && suggestedProjectsComponent} */}
      </MainWrapper>
    );
  }
}

ProjectHome.propTypes = {
  params: PropTypes.object,
  projectManager: PropTypes.object,
  repoManager: PropTypes.object,
  t: PropTypes.func,
  project: PropTypes.object,
};
